// extracted by mini-css-extract-plugin
export default {"btnContainer":"blacklist_btnContainer__PPWpG"};